module.exports = __webpack_public_path__ + "static/media/pledgeform.e1b87e92.png";